import {BotSlider} from '../index'
import {Link} from 'react-router-dom'
import {useEffect, useState} from "react";
import {getSplash} from "../../services/services";

const Bottombox = () => {

    const [dataNeeded, setData] = useState(false)
    const getdata = async () => {
        const res = await getSplash()
        if (res && res.data.code == 1) {

            setData(res.data)
        }
    }

    useEffect(() => {
        getdata().then()

    }, []);


    let content
    if (dataNeeded) {


        content = (
            <BotSlider info={dataNeeded}/>
        )
    }


    return (
        <>
            <section>
                <div className='columns mx-0 is-multiline navpadend150 navpadstart150  mt-6'>


                    <div className='column is-12 '>


                            <div className='is-flex  is-align-items-center mb-6'>
                                <img className='title-img' src={'/icons/point.png'} width={40} alt="icon"/>
                                <h3 className='is-size-4-mobile is-size-4 has-text-weight-bold kook '>
                                    خدمات ارائه شده در بازرگانی قاسمی
                                </h3>
                            </div>


                    </div>


                    <div className='column is-12'>
                        {
                            dataNeeded && (
                                <article className='kook is-size-4 has-text-justified '>

                                    {
                                        dataNeeded.options.about
                                    }
                                </article>
                            )
                        }

                    </div>


                    <div className='column is-12'>

                        {
                            content
                        }

                    </div>


                </div>


            </section>


        </>

    )
}
export default Bottombox